import React from 'react';

import Model from '@tripian/model';
import { MustTryCard } from '@tripian/react';
import { api } from '@tripian/core';

import './MustTryList.scss';

import useTrip from '../../../../hooks/useTrip';

interface IMustTryList {
  focus: (poi: Model.Poi) => void;
}

const MustTryList: React.FC<IMustTryList> = ({ focus }) => {
  const { tripReference } = useTrip();

  const getPois = (tasteId: number): Promise<Model.Poi[]> => {
    const tastesIds: Array<number> = [];
    tastesIds[0] = tasteId;
    return api.poisMustTrySearch({ cityId: tripReference?.city.id || 0, mustTryIds: tastesIds, limit: 100 });
  };

  return (
    <>
      {tripReference
        ? tripReference.city.tastes.map((taste) => (
            <div key={`taste-${taste.id}`}>
              <MustTryCard taste={taste} poiCardClicked={focus} fetchPois={getPois} />
            </div>
          ))
        : null}
    </>
  );
};

export default MustTryList;
